import { Cake, MapPin, PersonStanding, VenusAndMars } from 'lucide-react';
import { cloneElement, type ReactElement } from 'react';

import { Flex } from '@/components/base';
import TooltipV2 from '@/components/Tooltip/TooltipV2';
import useColor from '@/hooks/domain/useColor';
import useLocaleStore from '@/stores/LocaleStore';
import { ageGroupList, genderList } from '@/types/feedbackConst';

import { ValueWrapper } from '../ValueWrapper';
import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const DemographicField = (
  props: CommonFieldProps & {
    demographic?: Demographic;
  },
) => {
  const regionMap = useLocaleStore((state) => state.regionMap);
  const location = regionMap[props.demographic?.location || '']?.country;

  if (!props.showFull && !props.demographic) return null;

  return (
    <PropertyRowWrapper {...props} ai_generated>
      <Flex g={10}>
        <DemographicItem
          icon={<VenusAndMars className="text-gray-600" />}
          label="Gender"
          value={
            props.demographic?.gender &&
            genderList.get(props.demographic.gender)
          }
        />
        <DemographicItem
          icon={<Cake className="text-gray-600" />}
          label="Age"
          value={
            props.demographic?.age &&
            ageGroupList.get(props.demographic.age)
          }
        />
        <DemographicItem
          icon={<PersonStanding className="text-gray-600" />}
          label="Race"
          value={props.demographic?.race}
        />
        <DemographicItem
          icon={<MapPin className="text-gray-600" />}
          label="Location"
          value={location}
        />
      </Flex>
    </PropertyRowWrapper>
  );
};

const DemographicItem = ({
  icon,
  label,
  value,
}: {
  icon: ReactElement;
  label: string;
  value?: string;
}) => {
  const color = useColor();
  const clonedIcon = cloneElement(icon, {
    size: '1em',
    color: color.gray600,
  });
  return (
    <TooltipV2 tooltipNode={label}>
      <ValueWrapper>
        <Flex className="text-xs font-medium">{clonedIcon}</Flex>
        <Flex className="text-xs font-medium">{value || '-'}</Flex>
      </ValueWrapper>
    </TooltipV2>
  );
};
